import { Footer } from '@/features/shared/components/Footers/Footer'
import { type NextPageWithLayout } from '@/pages/_app'
import { ActivityPunchCardFab } from '@/features/shop/components/CategorySubNav/ActivityPunchCardFab'
import { attachLayout } from '@/features/shared/components/Headers/Layouts/attachLayout'

// use this function to wrap the page's component if the page doesn't need a header
export function withoutHeaderLayout<P extends object>(
  Component: NextPageWithLayout<P>,
  {
    suppressFooter,
    showActivityPunchCardButton,
  }: { suppressFooter?: boolean; showActivityPunchCardButton?: boolean } = {},
) {
  return attachLayout(Component, (page) => (
    <>
      {!!showActivityPunchCardButton && <ActivityPunchCardFab />}
      {page}
      {!suppressFooter && <Footer />}
    </>
  ))
}
